import Vue from 'vue'
import Router from 'vue-router'
import layout from '@/layout/LayoutList'
import index from '@/pages/NewHome'

const originalPush = Router.prototype.push
Router.prototype.push = function push (location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated') throw err
  })
}
// 页面组件（全部使用动态 import）
const news = () => import('@/pages/NewsPage')
const newsDetail = () => import('@/pages/NewsDetail')
const registerOrg = () => import('@/pages/RegisterOrg')
const registerPlanner = () => import('@/pages/RegisterPlanner')
const login = () => import('@/pages/LoginPage')
const forget = () => import('@/pages/ForgetPassword')
const personInfo = () => import('@/pages/PersonInfo')
const plannerIssueList = () => import('@/pages/PlannerIssueList')
const plannerQAList = () => import('@/pages/PlannerQAList')
const message = () => import('@/pages/CounselorMessage')
const issueDetail = () => import('@/pages/IssueDetail')
const issueQa = () => import('@/pages/IssueQa')

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'HomeLayout',
      component: layout,
      redirect: '/index',
      children: [
        {
          path: 'index',
          name: 'IndexPage',
          component: index
        },
        {
          path: 'news/:blockId',
          name: 'NewsHome',
          component: news
        },
        {
          path: 'newsDetail/:id',
          name: 'NewsDetail',
          component: newsDetail
        },
        {
          path: 'planner',
          name: 'planner',
          component: { render: h => h('router-view') },
          meta: {
            requireAuth: true
          },
          redirect: { name: 'PlannerIssueList' },
          children: [
            {
              path: 'plannerIssueList',
              name: 'PlannerIssueList',
              component: plannerIssueList
            },
            {
              path: 'issueDetail/:id',
              name: 'IssueDetail',
              component: issueDetail
            },
            {
              path: 'plannerQAList',
              name: 'PlannerQAList',
              component: plannerQAList
            },
            {
              path: 'issueQa/:id',
              name: 'IssueQa',
              component: issueQa
            },
            {
              path: 'message',
              name: 'CounselorMessage',
              component: message
            },
            {
              path: 'personInfo',
              name: 'PersonInfo',
              component: personInfo
            }
          ]
        }
      ]
    },
    {
      path: '/registerOrg',
      name: 'RegisterOrg',
      component: registerOrg
    },
    {
      path: '/registerPlanner',
      name: 'RegisterPlanner',
      component: registerPlanner
    },
    {
      path: '/login',
      name: 'LoginPage',
      component: login
    },
    {
      path: '/forget',
      name: 'ForgetPassword',
      component: forget
    }
  ],
  mode: 'hash'
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(res => res.meta.requireAuth)) {
    if (!window.localStorage.getItem('access_token')) {
      next({ path: '/login' })
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router
